import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import BoxButtonHeader from '../common/button/boxButtonHeader';
import Button from '../common/button/button';
import Form from './combustivelAjusteForm';

import { setModoTela, initForm, salvar, excluir, getLista, getListaTanque, getListaCombustivel, getListaUsuario } from './combustivelAjusteActions';

class CombustivelAjuste extends Component {

    componentWillMount() {
		this.props.getLista(this.props.sessao.id_empresa);
		this.props.getListaTanque(this.props.sessao.id_empresa);
		this.props.getListaCombustivel(this.props.sessao.id_empresa);
		this.props.getListaUsuario(this.props.sessao.id_empresa);
    }

    render() {
        return (
            <div>
                <ContentHeader title='Ajuste de Saldo' small='Cadastro' />
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<BoxButtonHeader>
					<Button
						text='Adicionar'
						type={'success'}
						icon={'fa fa-plus'}
						style={{ position: 'fixed' }}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm();
						}} />
				</BoxButtonHeader>
				<Table>
					<THead>
						<Tr>
							<Th>Data e Hora</Th>
							<Th>Tanque</Th>
							<Th>Combustível</Th>
							<Th alignRight>Qtd Sistema</Th>
							<Th alignRight>Qtd Física</Th>
							<Th>Responsável</Th>
							<Th alignCenter acoes>Ações</Th>
						</Tr>
					</THead>
					<TBody>
						{(this.props.lista).map(item => (
							<Tr key={item.id}>
								<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ajuste)}</Td>
								<Td>{item.identificacao_tanque}</Td>
								<Td>{item.nome_combustivel}</Td>
								<Td alignRight>{parseFloat(item.quantidade_sistema || 0).toFixed(4).replace('.', ',')}</Td>
								<Td alignRight>{parseFloat(item.quantidade_fisica || 0).toFixed(4).replace('.', ',')}</Td>
								<Td>{item.nome_responsavel}</Td>
								<Td alignCenter>
									<ButtonTable
										type={'warning'}
										icon={'fa fa-pencil'}
										event={() => {
											this.props.setModoTela('cadastro', item);
											this.props.initForm({
												...item,
												quantidade_sistema: item.quantidade_sistema.replace('.', ','),
												quantidade_fisica: item.quantidade_fisica.replace('.', ',')
											});
										}} />
									<ButtonTable
										type={'danger'}
										icon={'fa fa-trash-o'}
										event={() => {
											this.props.setModoTela('exclusao', item);
											this.props.initForm({
												...item,
												quantidade_sistema: item.quantidade_sistema.replace('.', ','),
												quantidade_fisica: item.quantidade_fisica.replace('.', ',')
											});
										}} />
								</Td>
							</Tr>
						))}
					</TBody>
				</Table>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.combustivelAjuste.modoTela,
	lista: state.combustivelAjuste.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaTanque, getListaCombustivel, getListaUsuario }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CombustivelAjuste);
